import * as React from 'react'

export const MenuIcon = () => {
  return (
    <svg width='34' height='24' viewBox='0 0 34 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 24H33.2308V20.3077H0V24ZM0 13.8462H33.2308V10.1538H0V13.8462ZM0 0V3.6923H33.2308V0H0Z'
        fill='#CCCCCC'
      />
    </svg>
  )
}
